import React from 'react';
import NursingCareCatalogManager from '../nursing/NursingCareCatalogManager';

export default function HeadDoctorNursingCarePage() {
  return <NursingCareCatalogManager />;
}
